import * as React from "react";

function SvgQuora(props, ref) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
      xmlns="http://www.w3.org/2000/svg"
      fill="#b92a27"
    >
      <title>Quora</title>
      <path d="M7.3799.9483A11.9628 11.9628 0 0 1 21.248 19.5397l2.4096 2.4225c.7322.7362.21 1.9905-.8272 1.9905l-10.7105.01a12.52 12.52 0 0 1-.304 0h-.02A11.9628 11.9628 0 0 1 7.3818.9503Zm7.3217 4.428a7.1717 7.1717 0 1 0-5.4873 13.2512 7.1717 7.1717 0 0 0 5.4883-13.2511Z" />
    </svg>
  );
}

export default React.forwardRef(SvgQuora);
